import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import Callback from './callback'

const ApiMixinPartNumber = {
  async apiPartNumberExcel(arg = { method: 'get', params: {}, formData: {} }) {
    let [err, res] = [null, null]
    const config = {
      responseType: 'arraybuffer',
      header: {
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    }
    const instance = axios.create(config)
    switch (arg.method) {
      case 'exportExcel':
        const listObj = {
          ids: [],
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          axios.post(
            encodeUrl(
              `/api/PartNumber/getexceltemplateasync/${arg.params.keyWords}/${arg.params.commodityCode}`
            ),
            arg.params.ids
          )
        )
        break
      default:
        ;[err, res] = await To(instance.get('/api/PartNumber/getemptyexceltemplateasync'))
    }
    return Callback.globalCBForOld(err, res)
  },
  async apiPartNumber(arg = { method: '', params: {}, formData: {} }) {
    let [err, res] = [null, null]
    if (arg.params.whereConditions === '') {
      arg.params.whereConditions = ' '
    }
    if (arg.params.ComponentCode === '') {
      arg.params.ComponentCode = ' '
    }
    switch (arg.method) {
      case 'create':
        ;[err, res] = await To(axios.post('/api/PartNumber/AddPartNumberAsync', arg.params))
        break
      case 'update':
        ;[err, res] = await To(axios.post('/api/PartNumber/UpdatePartNumberAsync', arg.params))
        break
      case 'commodity':
        ;[err, res] = await To(
          axios.get('/api/PartNumber/GetCommodityCodeDaoListAsync', arg.params)
        )
        break
      case 'delete':
        ;[err, res] = await To(axios.post('/api/PartNumber/DeletePartNumberAsync', arg.params))
        break
      case 'exportExcel':
        ;[err, res] = await To(
          axios.post(
            encodeUrl(
              `/api/PartNumber/getexceltemplateasync/${arg.params.keyWords}/${arg.params.commodityCode}`
            ),
            arg.params.ids
          )
        )
        break
      case 'importExcel':
        ;[err, res] = await To(axios.post('/api/PartNumber/uploadexcelasync', arg.formData))
        break
      default:
        const listObj = {
          ComponentCode: ' ',
          pageNo: 1,
          pageSize: 10,
          whereConditions: ' ',
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          axios.get(
            encodeUrl(
              `/api/PartNumber/GetPartNumberDaoListPagedAsync/${arg.params.ComponentCode}/${arg.params.pageNo}/${arg.params.pageSize}/${arg.params.whereConditions}`
            )
          )
        )
    }
    return Callback.globalCB(err, res)
  },
}

export default {
  methods: ApiMixinPartNumber,
}
